import React, { useState } from 'react';
import { adminGrantItem } from '../services/api';
import UserSearchInput from './UserSearchInput';

export default function GrantItemForm({ users }) {
  const [recipientId, setRecipientId] = useState('');
  const [itemType, setItemType] = useState('ROLE');
  const [days, setDays] = useState('7');
  const [xp, setXp] = useState('1000');
  const [isSellable, setIsSellable] = useState(true);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('Выдача...');

    let data;
    if (itemType === 'ROLE') {
      data = {
        recipientId, itemType,
        name: `Эксклюзивная роль (награда)`,
        description: `Выдано администратором. Действует ${days} дней после активации.`,
        metadata: { days: parseInt(days) },
        isSellable: isSellable
      };
    } else { // XP_BOOSTER
      data = {
        recipientId, itemType,
        name: `Бустер опыта (+${xp} XP)`,
        description: `Выдано администратором.`,
        metadata: { xp: parseInt(xp) },
        isSellable: isSellable
      };
    }

    try {
      await adminGrantItem(data);
      setMessage('Предмет успешно выдан в инвентарь!');
    } catch (error) {
      setMessage(error.response?.data?.error || 'Ошибка');
    }
  };

  return (
    <div className="grant-item-form">
      <h6>Выдать предмет в инвентарь</h6>
      <form onSubmit={handleSubmit}>
        <UserSearchInput users={users} onUserSelect={setRecipientId} />

        <select value={itemType} onChange={e => setItemType(e.target.value)}>
          <option value="ROLE">Эксклюзивная роль</option>
          <option value="XP_BOOSTER">XP Бустер</option>
        </select>

        {itemType === 'ROLE' ? (
          <input type="number" value={days} onChange={e => setDays(e.target.value)} placeholder="Кол-во дней" required />
        ) : (
          <input type="number" value={xp} onChange={e => setXp(e.target.value)} placeholder="Кол-во XP" required />
        )}
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#b9bbbe', fontSize: '0.9rem' }}>
          <input
            type="checkbox"
            checked={isSellable}
            onChange={e => setIsSellable(e.target.checked)}
          />
          Можно продать за поинты
        </label>
        <button type="submit">Выдать</button>
      </form>
      {message && <p className="form-message">{message}</p>}
    </div>
  );
}